export const display = (targetAdSelector: string) => `
googletag.cmd.push(function() {
    googletag.display("${targetAdSelector}");
});
`;
export default display;
